import React from "react";
import Lenis from "lenis";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Legacy from "./components/Legacy";
import Products from "./components/Products";
import Capabilities from "./components/Capabilities";
import Projects from "./components/Projects";
import Frontlines from "./components/Frontlines";
import Enquiry from "./components/Enquiry";
import Footer from "./components/Footer";
import FloatingCta from "./components/FloatingCta";
import CatalogueModal from "./components/CatalogueModal";
import "./App.css";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch(err) {
        console.error(err);
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="flex min-h-screen items-center justify-center bg-ink text-slate-300 font-body">
                    Something went wrong. Please refresh the page.
                </div>
            );
        }
        return this.props.children;
    }
}

function App() {
    const [catalogueOpen, setCatalogueOpen] = React.useState(false);

    React.useEffect(() => {
        const onOpen = () => setCatalogueOpen(true);
        window.addEventListener("ss:catalogue", onOpen);
        return () => window.removeEventListener("ss:catalogue", onOpen);
    }, []);

    React.useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <ErrorBoundary>
            <div className="relative bg-ink font-body text-white antialiased">
                <Nav />
                <main>
                    <Hero />
                    <Marquee />
                    <Legacy />
                    <Products />
                    <Capabilities />
                    <Projects />
                    <Frontlines />
                    <Enquiry />
                </main>
                <Footer />
                <FloatingCta />
                <CatalogueModal
                    open={catalogueOpen}
                    onClose={() => setCatalogueOpen(false)}
                />
                <div className="grain" aria-hidden="true" />
            </div>
        </ErrorBoundary>
    );
}

export default App;
